import { render, staticRenderFns } from "./FormulationList.vue?vue&type=template&id=8b72fa78&scoped=true&"
import script from "./FormulationList.vue?vue&type=script&lang=js&"
export * from "./FormulationList.vue?vue&type=script&lang=js&"
import style0 from "./FormulationList.vue?vue&type=style&index=0&id=8b72fa78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b72fa78",
  null
  
)

export default component.exports